export const currencies = ["KES-Kenya Shillings", "USD-US Dollars", "EUR-Euro"];
export const paymentModes = ["Cash", "Bank Transfer", "Cheque", "Mobile Money"];
export const companies = [
  "Turkenya",
  "Afromerch",
  "Precision",
  "Smart Flows",
  "Salve International",
  "Humfam Enterprises",
  "Mapleville Holdings"
];
export const accounts = [
  "Cash",
  "Bank",
  "Customer Overpayments",
  "Prepaid Expenses",
  "Inventory",
  "Accounts Receivable",
  "Accounts Payable",
  "Equity",
  "Loans Payable",
  "Retained Earnings",
  "Sales Returns",
];

export const transation_types = ["Sales", "Adjustment", "Refund"];
export const channels = ["NON-GDS", "Amadeus", "Galileo", "Sabre"];
export const routings = ["Local", "International"];
export const classes = ["Economy", "Business", "First Class"];
export const products = ["Flight", "Hotel Booking", "Car Hire"];
